import { faRightLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

export const SubstituteChip = () => {
  return (
    <Chip
      custom={{
        color: 'var(--c-neutral-1000)',
        background: 'var(--c-neutral-400)',
      }}
      size="smaller"
      iconLeft={() => <FontAwesomeIcon icon={faRightLeft} />}
      label={
        <FormattedMessage
          id="SubstituteChip.chip"
          defaultMessage="Substitute"
        />
      }
    />
  );
};
